import script from "./OperatorTerminalConfigPCUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorTerminalConfigPCUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorTerminalConfigPCUpsert.vue?vue&type=style&index=0&id=16c91700&lang=scss"

const __exports__ = script;

export default __exports__